import { CancelledError } from '@tanstack/react-query'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { SelectedService, validateSelectedService } from '#features/service-selection'
import { getCitySlugByName } from '#entities/city'
import { clientMeQueryOptions } from '#entities/client'
import { getServiceTemplateQueryOptions, ServiceType } from '#entities/order'

interface ClientNewOrderSearch {
  tab: ServiceType
  selectedServices: SelectedService[]
}

export const Route = createFileRoute('/client/_post-registration-required/new-order')({
  loader: async ({ context }) => {
    const { queryClient } = context

    const client = await queryClient.fetchQuery(clientMeQueryOptions)

    if (!client) {
      throw redirect({ to: '/client' })
    }

    try {
      await queryClient.ensureQueryData(getServiceTemplateQueryOptions(getCitySlugByName(client.city), client.id))
    } catch (error) {
      if (error instanceof CancelledError) return
      throw error
    }
  },

  validateSearch: (search): ClientNewOrderSearch => {
    const result: ClientNewOrderSearch = {
      tab: 'ROUTINE',
      selectedServices: [],
    }

    if (Array.isArray(search.selectedServices)) {
      result.selectedServices = search.selectedServices.map(validateSelectedService).filter(service => !!service)
    }

    if (['ROUTINE', 'COMPLEX', 'CUSTOM'].includes(search.tab as any)) {
      result.tab = search.tab as ServiceType
    }

    return result
  },
})
